<template>
  <div class="Ftim-box">
    <div class="Ftim-bt">
      <span>至德-</span>纪念堂
      <i></i>
    </div>

    <div class="">
      <div class="Ftim-top">
        <div class="Ftim-current">
          <em></em>当前位置：<span><router-link :to="{path:'/'}">首页</router-link> -- </span>纪念堂
        </div>
        
        <!-- <div class="Ftim-fanhui">
          <router-link to="/">
            <img src="../../../public/images/fanhui.png">
          </router-link>
        </div> -->
        
      </div>
    </div>

    <div class="Whole-tab">
      <span v-for="(item, index) in fisttab" :class="ison == item.id?'on':''" :key="index" @click="FistTab(item.id)">{{item.name}}</span>
    </div>

    <div class="Whole-tab">
      <span :class="avice == '-1'?'on':''" @click="Tab(-1)">全部</span>
      <span v-for="(item, index) in newlist" :class="avice == item.id?'on':''" :key="index" @click="Tab(item.id)">{{item.title}}</span>
    </div>

    <div class="Ftim-cent">

      <router-link :to="{path:'/memorialext',query:{id:item.id}}" class="Memorialst" v-for="(item, index) in infolist" :key="index">
        <img :src="$uploadUrl+item.outside_style.thumbnail" class="Memorialst-pic">
        <div class="Memorialst-name">{{item.name}}</div>
        <div class="Memorialst-worship">祭拜</div>
        <div class="Memorialst-count">{{item.pay_count}}</div>
      </router-link>


      <!-- <router-link :to="{path:'/ftimeinfo',query:{id:item.id}}" class="Ftim-list" v-for="(item, index) in infolist" :key="index">
        <img :src="item.cover">
        <div class="Ftim-name">{{item.title}}</div>
        <div class="Ftim-time">{{item.created_at}}</div>
      </router-link> -->
    </div>

    <div class="Ftim-more" @click="More" v-if="isgoto">加载更多</div>
   
  </div>
</template>
<script>
export default {
  data() {
    return {
      fisttab:[
        {
          name: '公立纪念堂',
          id: 1
        },
        {
          name: '私立纪念堂',
          id: 2
        }
      ],
      ison: 1,
      silist:[
        {
          title:'祖堂',
          id: 0
        },
        {
          title:'祠堂',
          id: 1
        },
        {
          title:'纪念堂',
          id: 2
        },
      ],
      topic_type: 1,
      tablist:[
        {
          title:'革命烈士',
          id: 0
        },
        {
          title:'抗日英雄',
          id: 1
        },
        {
          title:'农民起义领袖',
          id: 2
        },
        {
          title:'著名文学家',
          id: 3
        },
      ],
      newlist:[],
      avice: -1,
      infolist:[],
      page: 1,        //当前页码
      isgoto: false   //是否显示加载更多
    };
  },
  created(){
    this.getData();
    this.newlist = this.tablist;
  },
  mounted() {
  },
  methods: {
    //一级切换
    FistTab(id){
      if(this.ison != id){
        this.ison = id;
        this.infolist =[];
        this.page = 1;
        if(id == 1){
          this.topic_type = 1;
          this.newlist = this.tablist;
          this.avice = -1;
          this.getData();
        }else{
          this.newlist = this.silist;
          this.avice = -1;
          this.topic_type = 0;
          this.getData();
        }
      }
    },
    //二级切换
    Tab(id){
      if(this.avice != id){
        this.avice = id;
        this.page = 1;
        this.$layer.loading();
        let url;
        if(this.avice == -1){
          url = 'zhide/memorial?topic_type='+this.topic_type+'&page='+this.page
        }else{
          url = 'zhide/memorial?topic_type='+this.topic_type+'&type='+this.avice+'&page='+this.page
        }
        this.$http.get(url).then((res)=>{
        if(res.data.code == 200){
          this.$layer.closeAll('loading');
          this.infolist = res.data.data.data;
          if(res.data.data.next_page_url != null){
            this.isgoto = true;
            this.page+=1
          }else{
            this.isgoto = false;
          }
        }else{
          this.$layer.msg(res.data.message);
        }
      })
      }
    },

    //获取列表数据
    getData(){
      this.$layer.loading();
      let url;
      if(this.avice == -1){
        url = 'zhide/memorial?topic_type='+this.topic_type+'&page='+this.page
      }else{
        url = 'zhide/memorial?topic_type='+this.topic_type+'&type='+this.avice+'&page='+this.page
      }
      this.$http.get(url).then((res)=>{
        if(res.data.code == 200){
          this.$layer.closeAll('loading');
          this.infolist = this.infolist.concat(res.data.data.data);
          if(res.data.data.next_page_url != null){
            this.isgoto = true;
            this.page+=1
          }else{
            this.isgoto = false;
          }
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //加载更多
    More(){
      this.getData();
    }
  },
};
</script>
<style scoped>
  .Ftim-box{
    background: url(../../../public/images/dysjbjt.png) top no-repeat;
    margin-bottom: 60px;
  }
  .Ftim-bt{
    width: 1200px;
    margin: 72px auto 0;
    font-weight: bold;
    font-size: 48px;
    color: #333;
    line-height: 48px;
  }
  .Ftim-bt span{
    color: #D71E1C;
  }
  .Ftim-bt i{
    display: block;
    width: 48px;
    height: 4px;
    background: #D71E1C;
    margin-top: 30px;
  }
  .Ftim-top{
    width: 1240px;
    height: 74px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    border-radius: 20px 20px 0px 0px;
    margin: 74px auto 0;
  }
  .Whole-tab{
    width: 1200px;
    margin: 10px auto 0;
    display: flex;
    align-items: center;
  }
  .Whole-tab span{
    padding: 0px 20px;
    background: #F2F2F2;
    border-radius: 18px;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    text-align: center;
    line-height: 36px;
    margin-right: 15px;
    cursor: pointer;
  }
  .Whole-tab span.on{
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    color: #fff;
  }
  .Ftim-current{
    line-height: 74px;
    font-size: 16px;
    color: #333;
  }
  .Ftim-current em{
    display: inline-block;
    width: 12px;
    height: 12px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
    border-radius: 50%;
    margin: 0 10px 0 20px;
  }
  .Ftim-current span{
    color: #999;
  }
  .Ftim-current a{
    color: #999;
  }
  .Ftim-fanhui{
    width: 20px;
    height: 20px;
    margin-right: 30px;
  }
  .Ftim-cent{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
  }
  .Ftim-list{
    width: 285px;
    display: block;
    margin-top: 30px;
    margin-right: 0;
  }
  .Ftim-list:not(:nth-child(4n)){
    margin-right: 20px;
  }
  .Ftim-list img{
    width: 285px;
    height: 207px;
    border-radius: 12px;
  }
  .Ftim-name{
    font-size: 18px;
    color: #333333;
    line-height: 28px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 5px;
  }
  .Ftim-time{
    font-size: 16px;
    color: #D8D8D8;
    margin-top: 10px;
  }
  .Ftim-more{
    width: 180px;
    height: 36px;
    background: #F2F2F2;
    border-radius: 18px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 36px;
    text-align: center;
    margin: 40px auto 0;
    cursor: pointer;
  }
  .Memorialst{
    width: 224px;
    background: #D8D8D8;
    border-radius: 12px;
    position: relative;
    margin-top: 30px;
    margin-right: 0;
  }
  .Memorialst:not(:nth-child(5n)){
    margin-right: 20px;
  }
  .Memorialst-pic{
    width: 224px;
    height: 224px;
    background: #D8D8D8;
    border-radius: 12px;
  }
  .Memorialst-name{
    font-size: 18px;
    color: #333333;
    text-align: center;
    margin-top: 6px;
  }
  .Memorialst-worship{
    width: 64px;
    height: 28px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    border-radius: 14px;
    margin: 8px auto;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    line-height: 28px;
  }
  .Memorialst-count{
    position: absolute;
    top: 0;
    left: 0;
    width: 80px;
    height: 24px;
    background: linear-gradient( 137deg, #FFB73A 0%, #FE6809 100%);
    border-radius: 12px 12px 12px 0px;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 24px;
    text-align: center;
  }
</style>